import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ApiUrl } from 'Services/Services';
import { FaEye } from "react-icons/fa6";


const ITEMS_PER_PAGE = 5;

function Riders() {
    const navigate = useNavigate()
  const [riders, setRiders] = useState([]); // default empty array
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingRiderId, setEditingRiderId] = useState(null);
  const [newRider, setNewRider] = useState({
    name: '',
    username: '',
    password: '',
    vehicleType: '',
    phone: '',
    branchId: '',
    status: 'active',
  });

  const totalPages = Math.max(1, Math.ceil(riders.length / ITEMS_PER_PAGE));
  const paginatedData = Array.isArray(riders)
    ? riders.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE)
    : [];

  const fetchRiders = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/rider`);
      const data = response?.data;
      if (Array.isArray(data)) {
        setRiders(data);
      } else {
        setRiders([]); // fallback
        console.warn('Unexpected API response:', response.data);
      }
    } catch (error) {
      console.error('Fetch error:', error.message);
      setRiders([]);
    }
  };

  useEffect(() => {
    fetchRiders();
  }, []);

  const handleModalChange = (e) => {
    setNewRider({ ...newRider, [e.target.name]: e.target.value });
  };

  const handleAddRider = async () => {
    try {
      await axios.post(`${ApiUrl}/rider`, newRider);
      toast.success('Rider Created');
      resetModal();
      fetchRiders();
    } catch (error) {
      console.error('API error:', error.message);
      toast.warn(error.message);
    }
  };

  const handleUpdateRider = async () => {
    try {
      await axios.put(`${ApiUrl}/rider/${editingRiderId}`, newRider);
      toast.success('Rider Updated');
    //   resetModal();
      fetchRiders();
    //   resetModal()
    setIsModalOpen(false)
    } catch (error) {
      console.error('Update error:', error.message);
      toast.warn(error.message);
    }
  };

  const handleView = (id) => {
    navigate(`/admin/RiderDetail/${id}`)
  }

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${ApiUrl}/rider/${id}`);
      fetchRiders();
      toast.success('Rider Deleted');
    } catch (error) {
      console.log(error.message);
      toast.warn(error.message);
    }
  };

  const handleEdit = (id) => {
    const rider = riders.find((r) => r.id === id);
    if (rider) {
      setNewRider({
        name: rider.name,
        username: rider.username,
        password: '', // password not fetched for security
        vehicleType: rider.vehicleType,
        phone: rider.phone,
        branchId: rider.branchId,
        status: rider.status,
      });
      setEditingRiderId(id);
      setIsEditing(true);
      setIsModalOpen(true);
    }
  };

  const resetModal = () => {
    setNewRider({
      name: '',
      username: '',
      password: '',
      vehicleType: '',
      phone: '',
      branchId: '',
      status: 'active',
    });
    setIsModalOpen(false);
    setIsEditing(false);
    setEditingRiderId(null);
  };

  return (
    <div className="p-6">
      {/* Add Rider Button */}
      <div className="flex justify-end pb-5">
        <button
          onClick={() => {
            setIsEditing(false);
            resetModal();
            setIsModalOpen(true);
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Add Rider
        </button>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white w-full max-w-md rounded-xl p-6 shadow-lg">
            <h2 className="text-xl font-semibold mb-4">
              {isEditing ? 'Edit Rider' : 'Add Rider'}
            </h2>
          {/* ... inside your modal's JSX ... */}
<div className="space-y-4">
  <input name="name" placeholder="Name" value={newRider.name} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md" />
  <input name="username" placeholder="Username" value={newRider.username} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md" />
  {!isEditing && (
    <input type="password" name="password" placeholder="Password" value={newRider.password} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md" />
  )}
  
  {/* Vehicle Type Select Dropdown */}
  <select
    name="vehicleType"
    value={newRider.vehicleType}
    onChange={handleModalChange}
    className="w-full border px-4 py-2 rounded-md"
  >
    <option value="">Select Vehicle Type</option>
    <option value="Bike">Bike</option>
    <option value="Car">Car</option>
    <option value="Bicycle">Bicycle</option>
  </select>

  <input name="phone" placeholder="Phone" value={newRider.phone} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md" />
  <input name="branchId" placeholder="Branch ID" value={newRider.branchId} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md" />
  <select name="status" value={newRider.status} onChange={handleModalChange} className="w-full border px-4 py-2 rounded-md">
    <option value="active">Active</option>
    <option value="inactive">Inactive</option>
  </select>

  <div className="flex justify-end gap-2 pt-2">
    <button onClick={resetModal} className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300">Cancel</button>
    {isEditing ? (
      <button onClick={handleUpdateRider} className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700">Update</button>
    ) : (
      <button onClick={handleAddRider} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">Add</button>
    )}
  </div>
</div>

          </div>
        </div>
      )}

      {/* Riders Table */}
      <div className="overflow-x-auto bg-white shadow-md rounded-lg">
        <table className="min-w-full table-auto text-left text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Username</th>
              <th className="px-4 py-3">Vehicle Type</th>
              <th className="px-4 py-3">Phone</th>
              <th className="px-4 py-3">Branch ID</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((rider) => (
                <tr key={rider.id} className="border-b">
                  <td className="px-4 py-3">{rider.name}</td>
                  <td className="px-4 py-3">{rider.username}</td>
                  <td className="px-4 py-3">{rider.vehicleType}</td>
                  <td className="px-4 py-3">{rider.phone}</td>
                  <td className="px-4 py-3">{rider.branchId}</td>
                  <td className={`px-4 py-3 ${rider.status === 'active' ? 'text-green-600' : 'text-red-600'}`}>
                    {rider.status}
                  </td>
                  <td className="px-4 py-3 text-right space-x-2">
                    <button onClick={() => handleView(rider.id)} className="text-blue-500 hover:text-blue-700"> <FaEye /></button>
                    <button onClick={() => handleEdit(rider.id)} className="text-blue-500 hover:text-blue-700"><FaEdit /></button>
                    <button onClick={() => handleDelete(rider.id)} className="text-red-500 hover:text-red-700"><FaTrash /></button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4 text-gray-500">No riders found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {riders.length > 0 && (
        <div className="mt-4 flex justify-end items-center gap-4">
          <button className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
            Previous
          </button>
          <span className="text-sm">
            Page {currentPage} of {totalPages}
          </span>
          <button className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300" onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default Riders;
